import createTypes from 'redux-create-action-types';

export default createTypes(
  'ACTIVITIES_ADD',
  'ACTIVITIES_INITIALIZE',
  'ACTIVITIES_LOAD_MORE',
  'ACTIVITIES_LOAD_MORE_ERROR',
  'ACTIVITIES_LOAD_MORE_SUCCESS',
  'ACTIVITIES_MUTUAL_ADDRESS_UPDATE',
  'ACTIVITIES_MUTUAL_LOAD_MORE',
  'ACTIVITIES_MUTUAL_LOAD_MORE_ERROR',
  'ACTIVITIES_MUTUAL_LOAD_MORE_SUCCESS',
  'ACTIVITIES_MUTUAL_RESET',
  'ACTIVITIES_NEWS_LOAD_MORE',
  'ACTIVITIES_NEWS_LOAD_MORE_ERROR',
  'ACTIVITIES_NEWS_LOAD_MORE_SUCCESS',
  'ACTIVITIES_RESET',
  'ACTIVITIES_SET_LAST_SEEN',
  'ACTIVITIES_SET_STATUS',
  'ACTIVITIES_UPDATE',
  'ACTIVITIES_UPDATE_ERROR',
  'ACTIVITIES_UPDATE_SUCCESS',
);
